exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container[data-v-8a3b4562]{text-align:center}#qrcode[data-v-8a3b4562]{text-align:center;display:inline-block;margin:.52rem 0 .18rem;background:#fff;padding:.1rem}#qrcode img[data-v-8a3b4562]{width:132px;height:132px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8a3b4562","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/pass-status/components/QRcode.vue
// module id = tx9T
// module chunks = 1